/* Account */
export const COMMON_IMAGE_VIEWER = 'COMMON_IMAGE_VIEWER';
export const COMMON_IMAGE_VIEWER_RESET = 'COMMON_IMAGE_VIEWER_RESET';
